import Badge from './Badge'

export default Badge



// WEBPACK FOOTER //
// ./components/badge/index.js